
<template>
  <el-container class="pagination-list doing-task">
    <el-main>
      <!--XXX: 该页面不建议进行维护, 当前页面会列出所有人发布的流程的信息, 能查看该页面的账号拥有类似超管的权限, 不安全-->
      <div class="content">
        <el-form :inline="true" :model="process" ref="process" @keyup.enter.native="search">
          <el-form-item prop="processState" label="流程状态">
            <el-select v-model="process.processState" @change="search" placeholder="请选择流程状态" clearable>
              <el-option
                v-for="option in processStates"
                :key="option.key"
                :value="option.key"
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字" prop="keyword">
            <el-input v-model="process.keyword" placeholder="请输入关键字" clearable/>
          </el-form-item>
          <!--操作按钮-->
          <el-form-item class="process-operation-buttons">
            <el-button @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table class="table-list" :data="items" v-loading="loading" height="100%">
          <el-table-column property="processTitle" label="流程信息" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column property="startedTime" label="开始时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column property="endTime" label="结束时间" :formatter="formatDate" align="center"></el-table-column>
          <el-table-column property="taskName" label="当前节点" align="center"></el-table-column>
          <el-table-column property="taskAssignee" label="当前处理人" align="center"></el-table-column>
          <el-table-column property="status" label="流程状态" align="center"></el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="manageTask(scope.row,'viewAll')">管理</el-button>
              <!-- <el-button type="text" @click="cancelProcessTask(scope.row)">作废</el-button> -->
              <!-- <el-dropdown class="cust-dropdown" @command="handleCommand($event, scope.row)">
                <span class="el-dropdown-link">
                  <i class="fa fa-chevron-circle-down"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="endProcessTask" :disabled="scope.row.status==='已终止'">终止</el-dropdown-item>
                  <el-dropdown-item command="stateView">状态</el-dropdown-item>
                  <el-dropdown-item  v-if="scope.row.startNode!==scope.row.nodeId"  command="openTurnOnReassign">转交</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->

            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total,sizes, prev, pager, next,jumper "
            :total="pagination.total"
          ></el-pagination>
        </el-footer>
        <approval-comment
          :dialogVisible="commentVisible"
          :approvalCommentHistory="approvalCommentHistory"
          :currentNodeId="currentNodeId"
          @close="commentVisible=false"
          @viewState="viewTask"></approval-comment>
      </div>
    </el-main>
   <dialog-form-runtime @openDialog="openDialog" :formRuntimeDialog="formRuntimeDialog" @getTableData="getTableData"></dialog-form-runtime>
    <el-dialog
      class="turnon-reassign-dialog"
      title="转交"
      :visible.sync="turnOnReassignDialog.dialogVisible"
      width="540px"
      append-to-body
      center>
      <div>
       <el-form ref="turnForm" :model="turnOnReassignDialog">
         <el-form-item class="inform-scope" label="" prop="candidate" :rules="{required: true, message: '请选择转交人'}">
        <div class="inform-scope-content">
          <div class="left">转交给 <i class="el-icon-plus" @click="openTurnFormDialog"></i></div>
          <div class="right">
            <span class="candidate-item" v-for="item in turnOnReassignDialog.candidate" :key="item.id">{{item.name}}</span>
          </div>
        </div>
         </el-form-item>
        <div class="turnon-tip">
          <p>转交说明</p>
          <el-input type="textarea" v-model="turnOnReassignDialog.explain"></el-input>
        </div>
        </el-form>
       </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmTurnon">确 定</el-button>
        <el-button @click="turnOnReassignDialog.dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <new-select-people v-if="selectInformDialog.visable" :data="selectInformDialog" @getCandidate="getCandidate"></new-select-people>
  </el-container>
</template>

<script>
import ProcessStateView from './process-stateView.vue'
import ApprovalComment from './approval-comment'
import {processtMixin} from './mixin'
import DialogFormRuntime from '@/components/shared/dialog-form-runtime.vue'
import moment from 'moment'
import NewSelectPeople from '@/components/system/system/new-select-people'
export default {
  mixins: [processtMixin],
  name: 'ProcessInstanceList',
  data () {
    return {
      process: {
        processState: '',
        keyword: ''
      },
      processStates: [{
        text: '全部'
      }, {
        key: '1',
        text: '进行中'
      }, {
        key: '2',
        text: '已完成'
      }, {
        key: '3',
        text: '已终止'
      }, {
        key: '4',
        text: '已作废'
      }],
      pagination: {currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0},
      loading: false,
      items: [],
      instanceId: '',
      filters: {},
      showOpenDialog: false,
      // 转交
      turnOnReassignDialog: {
        dialogVisible: false,
        candidate: [],
        explain: '',
        processName: ''
      },
      selectInformDialog: {
        visable: false,
        data: [],
        title: '人员选择',
        isSingle: true,
        selectType: ['user']
      },
      formRuntimeDialog: {
        visible: false,
        id: '',
        width: '',
        disabled: false,
        dataId: '',
        taskId: '',
        type: 'process',
        comeFrom: 'instanceListEdit'
      }
    }
  },
  components: {
    ApprovalComment,
    ProcessStateView,
    DialogFormRuntime,
    NewSelectPeople
  },
  watch: {
    'pagination.currentPage' (val) {
      this.getTableData()
    },
    'pagination.pageSize' (val) {
      this.getTableData()
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    search () {
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.process.keyword,
        'processState': this.process.processState
      }
      this.getTableData()
    },
    manageTask (row) {
      this.formRuntimeDialog.title = '管理'
      this.formRuntimeDialog.type = 'process-view'
      this.formRuntimeDialog.width = 'full'
      this.formRuntimeDialog.instanceId = row.id
      this.formRuntimeDialog.currentNodeId = ''
      this.formRuntimeDialog.nodeId = row.nodeId
      // this.formRuntimeDialog.nodeType = row.type
      // this.formRuntimeDialog.taskId = row.taskId
      // this.formRuntimeDialog.instanceId = row.id
      // this.formRuntimeDialog.started = row.started
      // this.formRuntimeDialog.startedTime = row.startedTime
      this.formRuntimeDialog.visible = true
    },
    viewTask (row, type) {
      if (type) {
        this.$router.push({ name: 'process-view', params: { instanceId: row.id } })
      } else {
        this.showOpenDialog = true
        this.commentVisible = false
        this.$router.push({ name: 'process-view', params: { instanceId: this.approvalInstanceId, currentNodeId: row } })
      }
    },
    openDialog () {
      if (this.showOpenDialog) {
        this.commentVisible = true
        this.showOpenDialog = false
      }
    },
    cancelProcessTask (row) {
      this.$confirm('是否作废当前流程实例任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        customClass: 'publishMessageBox urgeMessageBox'
      }).then(() => {
        this.$axios.post(`/process-api/runtime/cancelFlow?instanceId=${row.id}`)
          .then((res) => {
            this.$message({
              showClose: true,
              message: '流程作废成功',
              type: 'success'
            })
            this.getTableData()
          })
      })
    },
    endProcessTask (row) {
      this.$confirm('是否终止当前流程实例任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center: true,
        customClass: 'publishMessageBox urgeMessageBox'
      }).then(() => {
        this.$axios.post(`/process-api/runtime/endProcessTask?instanceId=${row.id}`)
          .then((res) => {
            this.$message({
              showClose: true,
              message: '流程终止成功',
              type: 'success'
            })
            this.getTableData()
          })
      }).catch(() => {
      })
    },
    formatDate (row, column) {
      var data = row[column.property]
      if ((column.property === 'startedTime' || column.property === 'endTime') && data) {
        return moment(data).format('YYYY-MM-DD HH:mm')
      }
      return data
    },
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }

      params.filters = this.filters
      this.$axios.get('/process-api/runtime/instances/count', {params})
        .then((res) => {
          this.pagination.total = res.data
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
          }
        })
      this.$axios.get('/process-api/runtime/getInstances', {params})
        .then((res) => {
          this.items = res.data
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
    },
    handleCommand (e, row) {
      this[e](row)
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
    },
    openTurnOnReassign (row) {
      this.taskId = row.taskId
      this.instanceId = row.id
      this.currentNodeId = row.nodeId
      this.turnOnReassignDialog.started = row.started
      this.turnOnReassignDialog.startedTime = row.startedTime
      this.turnOnReassignDialog.processName = row.name
      this.turnOnReassignDialog.dialogVisible = true
      this.turnOnReassignDialog.candidate = []
      this.turnOnReassignDialog.candidate = []
      this.turnOnReassignDialog.explain = ''
    },
    openTurnFormDialog () {
      this.selectInformDialog.visable = true
      this.selectInformDialog.data = this.turnOnReassignDialog.candidate
    },
    getCandidate (data) {
      this.turnOnReassignDialog.candidate = data
      this.selectInformDialog.visable = false
      this.$refs.turnForm.validateField('candidate')
    },
    confirmTurnon () {
      this.$refs.turnForm.validate((valid) => {
        if (valid) {
          let params = {
            userId: this.turnOnReassignDialog.candidate[0].id,
            userName: this.turnOnReassignDialog.candidate[0].name,
            explain: this.turnOnReassignDialog.explain,
            instanceId: this.instanceId,
            nodeId: this.currentNodeId,
            taskId: this.taskId,
            processName: this.turnOnReassignDialog.processName,
            startName: this.turnOnReassignDialog.started,
            startTime: this.turnOnReassignDialog.startedTime
          }
          this.$axios.post('/process-api/runtime/reassignTask', params).then(res => {
            this.turnOnReassignDialog.dialogVisible = false
            this.getTableData()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/common.scss';
  .pagination-list.doing-task{
    .cust-dropdown {
    .el-dropdown-link {
      width: 12px;
      height: 12px;
      line-height: 12px;
      display: inline-block;
      margin-left: 10px;
      cursor: pointer;
      color: var(--light-5, #C5DFFF);

      &:hover {
        color: var(--light-4, #8CCDFF);
      }
    }
  }
  }
  .turnon-reassign-dialog {
  .inform-scope-content {
    width: 440px;
    display: flex;
    justify-content: space-between;
    .left {
      width: 120px;
      .el-icon-plus {
        color: #54ABF1;
        cursor: pointer;
        margin-left: 36px;
        &:active {
          color: #388DD2;
        }
      }
    }
    .right {
      width: calc(100% - 37px);
      line-height: 17px;
      padding-top: 6px;
      padding-left: 10px;
      .candidate-item {
        // 这个是去除前缀之前的宽度，先注释
        width: 74px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        display: inline-block;
        margin-right: 5px;
      }
    }
    .dialog-footer {
      .el-button--mini {
        padding: 5px 24px;
      }
    }
  }
  .turnon-tip {
    margin-top: 23px;
    p {
        margin-bottom: 9px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/process/runtime/process-instanceList-edit.vue